export const FIRST_ANNUAL_REPORTS_SUBSCRIPTION_YEAR = 2022
